import { render, staticRenderFns } from "./BulmaS3UploadInputSingle.vue?vue&type=template&id=0641010d&scoped=true&"
import script from "./BulmaS3UploadInputSingle.vue?vue&type=script&lang=js&"
export * from "./BulmaS3UploadInputSingle.vue?vue&type=script&lang=js&"
import style0 from "./BulmaS3UploadInputSingle.vue?vue&type=style&index=0&id=0641010d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0641010d",
  null
  
)

export default component.exports